import React from 'react';
import Route from 'react-router/Route';
import Redirect from 'react-router/Redirect';
import Switch from 'react-router/Switch';
import {getPath} from 'epic-common/src/route';
import {MotdView, ArticleWrapper, Error404, HomeView, Success} from '../views';

const redirectLocale = (destination, route) => {
    const path = getPath();
    let destPath = null;
    if (typeof destination === 'function') {
        destPath = destination(route.match.params);
    } else {
        destPath = destination;
    }
    const redirectUrl = `${path}${route.match.params.locale}${destPath}`;
    return (
        <Redirect to={redirectUrl} />
    );
};
const goNewsTitle = redirectLocale.bind(null, ({title}) => `/news/${title}`);
const goHome = redirectLocale.bind(null, '/home');

const getRoutes = function getRoutes() {
    const path = getPath();
    const routes = (
        <Switch>
            <Route path={`${path}motd`} component={MotdView} />
            <Route exact path={`${path}:locale/`} render={goHome} />
            <Route path={`${path}:locale/home`} component={HomeView} />
            <Route path={`${path}:locale/register-success`} component={Success} />
            <Route exact path={`${path}:locale/news`} component={Error404} />
            <Route path={`${path}news/category/:category`} component={Error404} />
            <Route path={`${path}:locale/blog/:articleLocale/:title`} render={goNewsTitle} />
            <Route path={`${path}:locale/news/:title`} component={ArticleWrapper} />
            <Route path={`${path}:locale/motd`} component={MotdView} />
            <Route component={Error404} />
        </Switch>
    );
    return routes;
};

export default getRoutes;

